export enum EXPANSION_PANEL_TYPE_ENUM {
  DEFAULT = 'default',
  IN_PROGRESS = 'inProgress',
  SUCCESS = 'success',
  ERROR = 'error',
}

/**
 * Platform-wide catalogue of eRM sprite icons.
 *
 * Each member maps to a `<symbol>` id inside
 * `assets/icons/erm-icons.svg`, prefixed with the `erm` namespace registered
 * by {@link DASH_BOARD_ICONS}. Adding a member here without adding the matching
 * `<symbol>` to the sprite renders an empty icon.
 *
 * @example
 * ```html
 * <wcg-icon [icon]="ermIcons.PRIORITY_HIGH" />
 * ```
 *
 * @example
 * ```typescript
 * readonly ermIcons = ERM_ICONS_ENUM;
 * ```
 */
export enum ERM_ICONS_ENUM {
  APARTMENT = 'erm:apartment',
  ARROW = 'erm:arrow',
  ARTICLE = 'erm:article',
  ASSIGNMENT_IND = 'erm:assignment_ind',
  AUTO_AWESOME = 'erm:auto_awesome',
  BELL = 'erm:bell',
  BUILD = 'erm:build',
  BUSINESS = 'erm:business',
  CALENDAR = 'erm:calendar',
  CELEBRATION = 'erm:celebration',
  CHECK_CIRCLE = 'erm:check_circle',
  CHECK_CIRCLE_FILLED = 'erm:check_circle_filled',
  CHEVRON_DOWN = 'erm:chevron_down',
  CHEVRON_RIGHT = 'erm:chevron_right',
  CIRCLE_CIRCLE = 'erm:circle_circle',
  COLLAB_HUB = 'erm:collab_hub',
  DESCRIPTION = 'erm:description',
  DONUT_SMALL = 'erm:donut_small',
  DOWNLOAD_ARROW = 'erm:download_arrow',
  EDIT_PENCIL = 'erm:edit_pencil',
  EDIT_PENCIL_OUTLINED = 'erm:edit_pencil_outlined',
  ERROR = 'erm:error',
  FILE = 'erm:file',
  FLASK = 'erm:flask',
  HOURGLASS_EMPTY = 'erm:hourglass_empty',
  LOCK_OPEN = 'erm:lock_open',
  PAPERCLIP = 'erm:paperclip',
  PDF_REVIEW = 'erm:pdf_review',
  PDF_SUCCESS = 'erm:pdf_success',
  PDF_WARNING = 'erm:pdf_warning',
  PENDING_ACTIONS = 'erm:pending_actions',
  PENDING_ACTIONS_OUTLINED = 'erm:pending_actions_outlined',
  PERSON = 'erm:person',
  PLACE = 'erm:place',
  PRIORITY_HIGH = 'erm:priority_high',
  PUSH_PIN = 'erm:push_pin',
  PUSH_PIN_TRANSPARENT = 'erm:push_pin_transparent',
  REFRESH = 'erm:refresh',
  REPORT = 'erm:report',
  REPORT_PROBLEM = 'erm:report_problem',
  SEARCH = 'erm:search',
  SUBMISSION_STATUS = 'erm:submission_status',
  SYNC = 'erm:sync',
  TASK = 'erm:task',
  TOGGLE_ON = 'erm:toggle_on',
  TRASH = 'erm:trash',
  UPLOAD = 'erm:upload',
  UPLOAD_FILLED = 'erm:upload_filled',
  USERS = 'erm:users',
  VACCINES = 'erm:vaccines',
  VPN_KEY = 'erm:vpn_key',
  WATCH_LATER = 'erm:watch_later',
  WATCH_LATER_OUTLINED = 'erm:watch_later_outlined',
  WCG_LOGO = 'erm:wcg_logo',
  WCG_MARK = 'erm:wcg_mark',
  WCG_MARK_MONO = 'erm:wcg_mark_mono',
  WITH_WCG_LOGO = 'erm:with_wcg_logo',
  WORK_OUTLINE = 'erm:work_outline',
}

export const WAITING_ON_YOU_ICON_MAPPER = new Map<string, ERM_ICONS_ENUM>([
  ['study', ERM_ICONS_ENUM.FLASK],
  ['site', ERM_ICONS_ENUM.PLACE],
]);

export const WAITING_ON_YOU_CONTAINER_NOTIFICATION_TYPE_MAPPER = new Map<
  string,
  string
>([
  ['todo', 'To-dos'],
  ['on_hold', 'Reviews'],
]);
